/**
 * LanguageSelector Component Translations
 * 
 * All translations for the LanguageSelector component across all supported languages.
 * This keeps component-specific translations close to the component.
 */

export const languageSelectorTranslations = {
  en: {
    'vaiu.profile_page.language': 'Language',
    'vaiu.profile_page.language_description': 'Choose your preferred language for the interface',
    'vaiu.profile_page.language_updated': 'Language updated successfully',
  },
  es: {
    'vaiu.profile_page.language': 'Idioma',
    'vaiu.profile_page.language_description': 'Elija su idioma preferido para la interfaz',
    'vaiu.profile_page.language_updated': 'Idioma actualizado exitosamente',
  },
  fr: {
    'vaiu.profile_page.language': 'Langue',
    'vaiu.profile_page.language_description': 'Choisissez votre langue préférée pour l\'interface',
    'vaiu.profile_page.language_updated': 'Langue mise à jour avec succès',
  },
  sq: {
    'vaiu.profile_page.language': 'Gjuha',
    'vaiu.profile_page.language_description': 'Zgjidhni gjuhën tuaj të preferuar për ndërfaqen',
    'vaiu.profile_page.language_updated': 'Gjuha u përditësua me sukses',
  },
  ru: {
    'vaiu.profile_page.language': 'Язык',
    'vaiu.profile_page.language_description': 'Выберите предпочитаемый язык интерфейса',
    'vaiu.profile_page.language_updated': 'Язык успешно обновлен',
  },
  pt: {
    'vaiu.profile_page.language': 'Idioma',
    'vaiu.profile_page.language_description': 'Escolha seu idioma preferido para a interface',
    'vaiu.profile_page.language_updated': 'Idioma atualizado com sucesso',
  },
  el: {
    'vaiu.profile_page.language': 'Γλώσσα',
    'vaiu.profile_page.language_description': 'Επιλέξτε την προτιμώμενη γλώσσα σας για τη διεπαφή',
    'vaiu.profile_page.language_updated': 'Η γλώσσα ενημερώθηκε με επιτυχία',
  },
  de: {
    'vaiu.profile_page.language': 'Sprache',
    'vaiu.profile_page.language_description': 'Wählen Sie Ihre bevorzugte Sprache für die Benutzeroberfläche',
    'vaiu.profile_page.language_updated': 'Sprache erfolgreich aktualisiert',
  },
  ro: {
    'vaiu.profile_page.language': 'Limbă',
    'vaiu.profile_page.language_description': 'Alegeți limba preferată pentru interfață',
    'vaiu.profile_page.language_updated': 'Limba a fost actualizată cu succes',
  },
  sr: {
    'vaiu.profile_page.language': 'Језик',
    'vaiu.profile_page.language_description': 'Изаберите жељени језик за интерфејс',
    'vaiu.profile_page.language_updated': 'Језик је успешно ажуриран',
  },
  pl: {
    'vaiu.profile_page.language': 'Język',
    'vaiu.profile_page.language_description': 'Wybierz preferowany język interfejsu',
    'vaiu.profile_page.language_updated': 'Język został zaktualizowany pomyślnie',
  },
};

